import React from 'react';

const WalletInstallGuide = ({ onClose }) => {
  return (
    <div className="wallet-install-overlay">
      <div className="wallet-install-modal">
        <div className="modal-header">
          <h3>Install Miden Wallet</h3>
          <button className="close-button" onClick={onClose}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <line x1="18" y1="6" x2="6" y2="18" stroke="currentColor" strokeWidth="2"/>
              <line x1="6" y1="6" x2="18" y2="18" stroke="currentColor" strokeWidth="2"/>
            </svg>
          </button>
        </div>
        
        <div className="modal-content">
          <div className="install-steps">
            <div className="step">
              <div className="step-number">1</div>
              <div className="step-content">
                <h4>Download the Extension</h4>
                <p>Visit the Chrome Web Store and install the Miden Wallet extension.</p>
                <a 
                  href="https://chromewebstore.google.com/detail/miden-wallet/ablmompanofnodfdkgchkpmphailefpb?hl=en" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="install-link"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" style={{marginRight: '8px'}}>
                    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" stroke="currentColor" strokeWidth="2"/>
                    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" stroke="currentColor" strokeWidth="2"/>
                  </svg>
                  Install Miden Wallet
                </a>
              </div>
            </div>
            
            <div className="step">
              <div className="step-number">2</div>
              <div className="step-content">
                <h4>Create Your Account</h4>
                <p>Open the extension and create a new Miden account or import an existing one.</p>
              </div>
            </div>
            
            <div className="step">
              <div className="step-number">3</div>
              <div className="step-content">
                <h4>Connect to MidenHub</h4>
                <p>Refresh this page and click "Connect Wallet" to link your account.</p>
              </div>
            </div>
          </div>
          
          <div className="features">
            <h4>What you'll get:</h4>
            <ul>
              <li>Secure private key management</li>
              <li>Transaction signing and submission</li>
              <li>Account balance tracking</li>
              <li>Note consumption capabilities</li>
            </ul>
          </div>
        </div>
        
        <div className="modal-footer">
          <button className="refresh-button" onClick={() => window.location.reload()}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" style={{marginRight: '8px'}}>
              <path d="M1 4v6h6" stroke="currentColor" strokeWidth="2"/>
              <path d="M23 20v-6h-6" stroke="currentColor" strokeWidth="2"/>
              <path d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15" stroke="currentColor" strokeWidth="2"/>
            </svg>
            Refresh Page
          </button>
        </div>
      </div>
    </div>
  );
};

export default WalletInstallGuide;
